import React from 'react';
import PropTypes from 'prop-types';

export default function Fire(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4903 11.2409C17.1594 10.4595 16.6784 9.75812 16.0773 9.18072L15.5812 8.70324C15.5644 8.68747 15.5441 8.67628 15.5222 8.67065C15.5003 8.66502 15.4774 8.66512 15.4555 8.67095C15.4336 8.67678 15.4134 8.68815 15.3967 8.70407C15.38 8.71999 15.3673 8.73997 15.3596 8.76225L15.1381 9.42929C15 9.84776 14.746 10.2752 14.3864 10.6954C14.3625 10.7222 14.3352 10.7294 14.3165 10.7312C14.2977 10.733 14.2687 10.7294 14.2432 10.7044C14.2193 10.6829 14.2074 10.6507 14.2091 10.6185C14.2721 9.54196 13.9653 8.32769 13.2937 7.00613C12.7381 5.90811 11.9659 5.05151 11.0011 4.45421L10.2972 4.01965C10.2051 3.96242 10.0875 4.03753 10.0926 4.1502L10.1301 5.00859C10.1557 5.59515 10.0909 6.11376 9.9375 6.54475C9.75 7.0723 9.48068 7.56229 9.13636 8.00222C8.89674 8.30795 8.62515 8.58449 8.3267 8.82663C7.60791 9.40634 7.02343 10.1491 6.61704 10.9994C6.21166 11.8571 6.00049 12.8014 6 13.7588C6 14.6029 6.15852 15.4201 6.47216 16.1909C6.775 16.933 7.21203 17.6065 7.75909 18.1741C8.31136 18.7464 8.95227 19.197 9.66647 19.51C10.4062 19.8355 11.1903 20 12 20C12.8097 20 13.5937 19.8355 14.3335 19.5118C15.046 19.2007 15.6938 18.7469 16.2409 18.1759C16.7932 17.6037 17.2261 16.9348 17.5278 16.1927C17.841 15.424 18.0016 14.5965 18 13.7606C18 12.8879 17.8295 12.0402 17.4903 11.2409V11.2409Z"
        fill={props.color}
      />
    </svg>
  );
}

Fire.defaultProps = {
  color: '#fff'
};

Fire.propTypes = {
  color: PropTypes.string,
};
